import { useTranslation } from 'next-i18next'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'
import SeoHead from '@/components/seo/SeoHead'

export default function PageArtikel() {
  const { t } = useTranslation('articles')

  return (
    <>
      <SeoHead
        title={t('title')}
        description={t('description')}
        dePath="artikel"
        enPath="articles"
      />

      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="articles" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'articles'])
export { getStaticPaths, getStaticProps }
